export enum StyleBreakpoints {
    Implicit = 0,
    Xsmall = 360,
    Small = 460,
    Medium = 768,
    Large = 1024,
    Xlarge = 1200
}
